import { mapValues, reduce, values, omitBy, pick, isNil, isEmpty } from 'lodash-es';
import qs from 'query-string';
import * as PathToRegexp from 'path-to-regexp';
export class RouteMapping {
    constructor(initialRoutes) {
        this.routes = initialRoutes;
        this.compiledRoutes = mapValues(this.routes, route => ({
            ...route,
            pathRegexp: PathToRegexp.pathToRegexp(route.path),
            compiledPath: PathToRegexp.compile(this.processNonCapturingEnumParameters(route.path))
        }));
        this.pageNameByPath = reduce(this.routes, (res, route) => {
            res[route.path] = route.pageName;
            return res;
        }, {});
        this.pageNameByPathWithNestedPath = reduce(this.routes, (res, route) => {
            if (route.nestedRoutes) {
                Object.values(route.nestedRoutes).forEach(nestedRoute => {
                    const fullPath = this.getPathWithNestedPath(route.path, nestedRoute.path);
                    res[fullPath] = route.pageName;
                });
            }
            return res;
        }, {});
        this.orderedRoutes = values(this.compiledRoutes).sort(({ priority: firstPriority = 0 }, { priority: secondPriority = 0 }) => secondPriority - firstPriority);
    }
    processNonCapturingEnumParameters(path) {
        return path.replace(/\((\w+)\|\w+\)/g, (_, firstOption) => firstOption);
    }
    getPathWithNestedPath(routePath, nestedRoutePath) {
        return `${routePath.replace(/\/$/g, '')}/${nestedRoutePath}`;
    }
    getPathByPageName(...[pageName, parameters]) {
        if (!parameters) {
            return this.processNonCapturingEnumParameters(this.routes[pageName].path);
        }
        const result = this.compiledRoutes[pageName].compiledPath(parameters);
        const queryParams = omitBy(pick(parameters, this.routes[pageName].queryParams), isNil);
        if (isEmpty(queryParams)) {
            return result;
        }
        const queryString = qs.stringify(queryParams, { arrayFormat: 'bracket' });
        return `${result}?${queryString}`;
    }
    getPageNameByPath(path) {
        const exactMatch = this.pageNameByPath[path];
        if (exactMatch) {
            return exactMatch;
        }
        const withNestedPathMatch = this.pageNameByPathWithNestedPath[path];
        if (withNestedPathMatch) {
            return withNestedPathMatch;
        }
        const matchedRoute = this.orderedRoutes.find(({ pathRegexp }) => pathRegexp.exec(path));
        return matchedRoute?.pageName ?? null;
    }
    getNestedRoutePathByPageName(pageName, nestedRouteName) {
        const nestedRoutes = this.routes[pageName]['nestedRoutes'];
        return nestedRoutes?.[String(nestedRouteName)].path;
    }
    getOrderedRoutes() {
        return this.orderedRoutes;
    }
    isHeaderHiddenByPageName(...[pageName]) {
        return !!this.routes[pageName].isHeaderHidden;
    }
    getRedirectRulesByPageName(...[pageName]) {
        return this.routes[pageName].redirectRules;
    }
    getAuth0CallbackPaths() {
        return Object.values(this.routes)
            .filter(({ isAuth0CallbackRoute }) => isAuth0CallbackRoute)
            .map(({ path }) => path);
    }
}
//# sourceMappingURL=route-mapping.js.map